// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
// Store
import {Store} from '@ngxs/store';
import {AppState} from '../state/app.state';
import {SetReleaseNotes, SetDependenciesVersion} from '../action/state.action';
import {AppVersion} from '../model/config-file.model';
// Model
import {SystemApp} from './model/system-info.model';
// Other
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
// Services
import {ConfigService} from '../service/config.service';
import { AppInformationService } from '../service/app-info.service';
import { AppStateModel } from '../model/app.state.model';

@Component({
	selector: 'cv-system-info',
	templateUrl: './system-info.component.html',
	styleUrls: ['./system-info.component.scss']
})
export class SystemInfoComponent implements OnInit, OnDestroy {
	version$: Observable<AppStateModel> = this.store.select(AppState.getAppState);

	private atComponentDestroy = new Subject();
	public appVersion: AppVersion = null;
	public systems: any = [];

	public releasesNotes: any = {
		open: false,
		notes: []
	};

	constructor(
		private store: Store,
		private configService: ConfigService,
		private appInfo: AppInformationService
	) {

	}

	ngOnInit(): void {
		this.version$.pipe(
			takeUntil(this.atComponentDestroy),
		).subscribe((app: AppStateModel) => {
			const appVersion = app[this.appInfo.appName].version;
			if (appVersion && appVersion !== null && this.appVersion === null) {
				this.appVersion = appVersion;
				this.systems = [];
				if (this.appVersion.modules) {
					for (const [key, value] of Object.entries(this.appVersion.modules)) {
						const systemApp = SystemApp.app[key];
						this.systems.push({
							app: systemApp,
							version: {
								name: key,
								number: value
							},
							subDetail: {
								open: false
								// Whatever you want to put here
							},
							dependencies: []
						});
					}
				}
			}
		});
		// Get All Release Notes
		this.configService.getDependenciesVersions(this.appVersion.environment).subscribe((data: any) => {
			this.store.dispatch(new SetDependenciesVersion(data, this.appInfo.appName));
			this.systems.forEach(system => {
				const deps = system.app.dependencies;
				const dependencies = [];

				for (const [key, value] of Object.entries(data)) {
					if (deps.indexOf(key) > -1) {
						dependencies.push(value);
					}
				}

				system.dependencies = dependencies;
			});
		});
		// Get All Release Notes
		this.configService.getReleaseNotes().subscribe((releaseNotesOf: any) => {
			// this.releasesNotes.notes = releaseNotesOf;
		});
	}

	/**
	 * Open the system notes
	 * @param event
	 */
	public openNotes(event: any, system: any): void {
		const systemNotes = this.releasesNotes.notes.find((release: any) => release.system === system.app.key);
		if (systemNotes) {
			this.store.dispatch(new SetReleaseNotes(systemNotes.release[0],this.appInfo.appName)).subscribe(() => {
				this.releasesNotes.open = true;
			});
		}
	}

	/**
	 * To send you back to the previous page
	 * @param event
	 */
	public goBack(event: any): void {
		window.history.back();
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
